import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '', children: [
      { path: 'de/:ID', component: HomeComponent },
      { path: 'en/:ID', component: HomeComponent },
    ]
  },
  { path: '**', redirectTo: '/de/x', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
